import React from 'react'
import StatusApplication from './StatusApplication';
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const RevisedPolicyPaymentDueApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editNewApplications.role,
    permissionsConfig.editNewApplications.action,
    permissionsConfig.editNewApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteNewApplications.role,
    permissionsConfig.deleteNewApplications.action,
    permissionsConfig.deleteNewApplications.type
  );

    return (
        <StatusApplication appStatus="12" title="Revised Policy Payment Due" subTitle="Revised Policy Payment Due" application_type="0" pageFrom="revised-policy-payment-due-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
    )
}

export default RevisedPolicyPaymentDueApplications